import PropTypes from 'prop-types';
import styles from './preset-category-card.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import Icon, { variants as iconVariants } from '../../../atoms/icon';
import Checkbox from '../../../atoms/checkbox';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import InteractiveElement from '../../../atoms/interactive-element';

const className = augmentClassName(styles);

const PresetCategoryCard = ({ card, onChange }) => {
  const containerClass = card.checked ? 'preset-category-card-checked' : 'preset-category-card';

  //To match the designs these 2 icons need to be styled with the stroke property, all others with the fill
  const svgClass = ['StarOutline', 'Product'].includes(card.icon)
    ? 'card-icon-stroke'
    : 'card-icon-fill';
  return (
    <Col
      sm={12}
      md={6}
      lg={4}
      // TIAA Analytics Tracking
      id={card.title.replace(/ /g, '_')}
      // END TIAA Analytics Tracking
    >
      <InteractiveElement
        as='Container'
        fluid
        {...className('root', containerClass)}
        tabIndex='0'
        aria-label={`${card.title} Preset category`}
        id={card.title}
        onClick={onChange}
      >
        <Row {...className('justify-content-between', 'align-items-center', 'px-4', 'pt-2')}>
          <Col>
            <Row>
              <Icon variant={card.icon} {...className(svgClass, 'mr-2')} />
              <h3 {...className('title')}>{card.title}</h3>
            </Row>
          </Col>
          <Col xs={1}>
            <Checkbox
              label={card.title}
              ariaLabel={`${card.title} filter`}
              id={card.title}
              onChange={onChange}
              checked={card.checked || false}
              checkedColor="#009FDB"
              isCategoryCard={true}
            />
          </Col>
        </Row>
        <Row {...className('px-4')}>
          <Col {...className('p-0')}>
            <p {...className('description')}>{card.description}</p>
          </Col>
        </Row>
      </InteractiveElement>
    </Col>
  );
};

PresetCategoryCard.propTypes = {
  card: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.oneOf(Object.keys(iconVariants)),
    checked: PropTypes.bool
  }),
  onChange: PropTypes.func
};

export default PresetCategoryCard;
